import { useEffect, useMemo, useRef } from 'react'
import { throttle } from 'throttle-debounce'

const useScroll = (
  callback: (event: any) => void,
  scrollElementRef: any
) => {
  const callbackRef = useRef<(event: any) => void>()
  const throttledCallback = useMemo(() => throttle(250, false, (event) => {
    if (callbackRef.current) {
      callbackRef.current(event)
    }
  }), [callbackRef])

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const scrollElement = scrollElementRef.current
    if (!scrollElement) {
      return
    }

    scrollElement.addEventListener('scroll', throttledCallback)
    return () => {
      scrollElement && scrollElement.removeEventListener('scroll', throttledCallback)
    }
  }, [scrollElementRef, throttledCallback])
}

export default useScroll
